<template>
    <select v-model="valueModel" class="form-control">
        <option>{{resource('JourneyBuilder_JourneyDropdown_PlaceholderText')}}</option>
        
        <template v-for="journey in journeys">
            <option v-bind="getJourneyOptionAttributes(journey)">
                {{journey.name}}
            </option>
            
            <optgroup v-if="journey.children.length" :label="journey.name">
                <template v-for="subJourney in journey.children">
                    <option v-bind="getJourneyOptionAttributes(subJourney)">
                        {{subJourney.name}}
                    </option>
                </template>
            </optgroup>
        </template>
    </select>
</template>

<script>
    import api from '@modules/JourneyBuilder/api';
    import {bootstrapDangerGrowl as errorGrowl} from "@core/Util/growler";
    
    import resourceMixin from "@core/Util/Mixins/resources";
    
    import VSelect from 'vue-select';

    export default {
        components: {
            VSelect
        },
        mixins: [resourceMixin],
        async created() {
            const vm = this;
            
            try {
                const journeys = await api.getJourneys();

                //Allow providing of journeys not in our collection while preventing duplicate journeys
                const unknownExtraJourneys = this.extraJourneys.reduce((extraJourneys, extraJourney) => {
                    if(!journeys.some(j => j.id === extraJourney.id)){
                        //Ensure all required properties are present
                        extraJourneys.push(Object.assign({
                            children: [],
                            name: extraJourney.id
                        }, extraJourney));
                    }

                    return extraJourneys;
                }, []);

                vm.journeys = [...journeys, ...unknownExtraJourneys];
            } catch(err) {
                errorGrowl(err);
            }
        },
        methods: {
            getJourneyOptionAttributes(journey){
                return {
                    disabled: this.disabledJourneyIds.some(jId => jId === journey.id),
                    value: journey.id,
                    selected: journey.id === this.valueModel
                }
            }
        },
        computed: {
            valueModel: {
                get(){
                    return this.value;
                },
                set(value){
                    this.$emit('input', value);
                }
            }
        },
        data: () => ({
            journeys: []
        }),
        props: {
            value: {
                type: String,
                required: false
            },
            extraJourneys: {
                type: Array,
                required: false,
                default: () => ([])
            },
            disabledJourneyIds: {
                type: Array,
                required: false,
                default: () => ([])
            }
        }
    }
</script>